import { createStore, Store } from 'redux'
import reducers, { RootState } from './reducers'

const store: Store<RootState> = createStore(reducers)

export type AppDispatch = typeof store.dispatch

export default store
